export const SUB_COMMUNITIES_KEY = 'isShowSubCommunities';
export const TALENTS_KEY = 'isShowTalents';
export const BANNER_MAINTENANCE_KEY = 'isShowBannerMaintenance';